var map = {
	"./bg": "lSAM",
	"./bg.svg": "lSAM",
	"./image-adaptable": "WFYJ",
	"./image-adaptable.svg": "WFYJ",
	"./image-aus-gov-security-policies": "1Z/k",
	"./image-aus-gov-security-policies.svg": "1Z/k",
	"./image-aws-data-centres": "Er2X",
	"./image-aws-data-centres.svg": "Er2X",
	"./image-flexible": "zFBy",
	"./image-flexible.svg": "zFBy",
	"./image-highly-available": "wksZ",
	"./image-highly-available.svg": "wksZ",
	"./image-observable": "T2+L",
	"./image-observable.svg": "T2+L",
	"./image-transparent-security": "DqVr",
	"./image-transparent-security.svg": "DqVr",
	"./image-work-efficiently": "qp1m",
	"./image-work-efficiently.svg": "qp1m"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "alyc";